import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/demo/shared/shared.module';
import { ProfileService } from 'src/app/tabms/services/admin/profile/profile.service';
import { TranslateService } from '@ngx-translate/core';
import { changePasswordDto } from 'src/app/tabms/models/base/base';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { OPERERROR } from 'src/app/tabms/tab-consts';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ChangePasswordValidationService } from 'src/app/tabms/services/validation/changePasswordValidation/change-password-validation.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [CommonModule, SharedModule],
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss'
})
export class ChangePasswordComponent implements OnInit {
  // public props
  hide = true;
  newHide = true;
  conHide = true;
  password: string;
  passwordStrength: string;
  oldPassword: string;

  form: FormGroup;
  submitted = false;
  private updatingValidity = false;

  constructor(
    private profileService: ProfileService,
    private translate: TranslateService,
    private dialogRef: MatDialogRef<ChangePasswordComponent>,
    private baseService: BaseService,
    private fb: FormBuilder,
    private customValidator: ChangePasswordValidationService
  ) {}

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm() {
    this.form = this.fb.group(
      {
        currentPassword: ['', [Validators.required]],
        newPassword: ['', Validators.compose([Validators.required, this.customValidator.patternValidator()])],
        confirmPassword: ['', [Validators.required]]
      },
      {
        validator: [this.customValidator.MatchPassword('newPassword', 'confirmPassword'), this.newPasswordDifferentFromOld()]
      }
    );
    this.form.get('currentPassword').valueChanges.subscribe(() => {
      if (!this.updatingValidity) {
        this.updatingValidity = true;
        this.form.get('newPassword').updateValueAndValidity();
        this.updatingValidity = false;
      }
    });

    this.form.get('newPassword').valueChanges.subscribe(() => {
      if (!this.updatingValidity) {
        this.updatingValidity = true;
        this.form.get('newPassword').updateValueAndValidity();
        this.updatingValidity = false;
      }
    });
  }

  // public method
  checkPasswordStrength() {
    const passwordStrengthRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    const password = this.password;

    if (passwordStrengthRegex.test(password)) {
      this.passwordStrength = this.translate.instant('strong');
    } else if (password.length >= 8) {
      this.passwordStrength = this.translate.instant('medium');
    } else {
      this.passwordStrength = this.translate.instant('weak');
    }
  }

  newPasswordDifferentFromOld() {
    return (formGroup: FormGroup) => {
      const currentPassword = formGroup.get('currentPassword').value;
      const newPassword = formGroup.get('newPassword').value;

      if (currentPassword && newPassword && currentPassword === newPassword) {
        formGroup.get('newPassword').setErrors({ sameAsOldPassword: true });
      } else {
        return null;
      }
    };
  }

  get formControl() {
    return this.form.controls;
  }

  onSubmit() {
    this.submitted = true;
    // console.log('change pass form', this.form);
    if (this.form.valid) {
      let data: changePasswordDto = { currentpassword: this.form.value.currentPassword, newpassword: this.form.value.newPassword };
      // console.log('change pass form', data);
      this.profileService.changePassword(data).subscribe(
        (res) => {
          this.baseService.showSuccessMessage('PasswordChangedSuccessfully');
          this.dialogRef.close();
        },
        (err) => {
          if (err?.message == 'Incorrect password.') this.baseService.showErrorMessage('Incorrect password.');
          else this.baseService.showErrorMessage(OPERERROR);
          console.log('err', err);
        }
      );
    }
  }

  password_type = [
    {
      title: 'AtLeast8Characters'
    },
    {
      title: 'AtLeast1LowerLetter'
    },
    {
      title: 'AtLeast1UppercaseLetter'
    },
    {
      title: 'AtLeast1Number'
    },
    {
      title: 'AtLeast1SpecialCharacters'
    }
  ];
}
